import Card from '@amzn/meridian/card';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React, { ReactNode } from 'react';
import Link from '@amzn/meridian/link';
import Tag from '@amzn/meridian/tag';
import Column from '@amzn/meridian/column';
import type {
  ActiveAssociateProfilePlacement,
  PendingAssociateProfilePlacement,
  TransferredInAssociateProfilePlacement,
} from 'src/services/associateProfile/types';
import { ALL_ACCOMMODATION_STATUS_NAMES } from 'src/config/AccommodationStatusNames';
import moment from 'moment';

interface PlacementCardLayoutProps {
  placement:
    | PendingAssociateProfilePlacement
    | TransferredInAssociateProfilePlacement
    | ActiveAssociateProfilePlacement;
  children?: ReactNode;
}

const isActivePlacement = (placement: any): placement is ActiveAssociateProfilePlacement => {
  return 'timeInActive' in placement;
};

const PlacementCardLayout = ({ children, placement }: PlacementCardLayoutProps) => (
  <Card spacingInset="400 450" minWidth="750px">
    <Column spacing="400">
      <Column spacing="200">
        <Row widths={['250px', '300px', 'fill']}>
          <Text type="h100" tag="span">
            Case ID:&nbsp;
            <Link type="secondary">
              {placement.accommodationType} | {placement.caseId}
            </Link>
          </Text>
          <Row spacing="300">
            {placement.additionalTags.map((tag) => (
              <Tag
                type={
                  isActivePlacement(placement) && ALL_ACCOMMODATION_STATUS_NAMES.includes(tag) ? 'success' : 'neutral'
                }
              >
                {tag}
              </Tag>
            ))}
          </Row>
          <Row spacing="300" alignmentHorizontal="end">
            Actions
          </Row>
        </Row>
        <Row spacing="200">
          <Text color="secondary">
            Last Updated: {moment(placement.updatedAt).format('MM/DD/YYYY [at] h:mma')} UTC •
          </Text>
          <Link
            href={`https://phonetool.amazon.com/users/${placement.updatedBy}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {placement.updatedBy}@
          </Link>
        </Row>
      </Column>
      <Row spacing="600">{children}</Row>
    </Column>
  </Card>
);

export default PlacementCardLayout;
